<div class="tile">
  <!-- Spinner while loading -->
  <ng-container *ngIf="!initialized">
    <div class="loading-container">
      <mat-spinner></mat-spinner>
    </div>
  </ng-container>

  <ng-container *ngIf="initialized">
    <!-- Edit Mode -->
    <div *ngIf="mode === UserBoardComponentMode.Edit" class="bottom-spacing">

      <div class="first-input-row">
        <!-- Header Input -->
        <mat-form-field class="w-full" appearance="fill">
          <mat-label>Chart Header</mat-label>
          <input matInput [(ngModel)]="model.header" />
        </mat-form-field>

      </div>

      <div class="first-input-row">
        <!-- Dataset Selection -->
        <mat-form-field appearance="fill" class="flex-1">
          <mat-label>Add GroupBy</mat-label>
          <mat-select [(ngModel)]="selectedGroupBy" (selectionChange)="onDatasetChange()">
            <mat-option *ngFor="let gDataset of groupByDatasets" [value]="gDataset.dataset.datasetReferenceTable.datasetId">
              {{ gDataset.dataset.datasetReferenceTable.datasetName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- FieldToDisplay Selection -->
        <mat-form-field appearance="fill" class="flex-1" *ngIf="selectedGroupBy">
          <mat-label>Select FieldName</mat-label>
          <mat-select [(ngModel)]="selectedField">
            <mat-option *ngFor="let pick of getDatasetFieldsToDisplay()" [value]="pick">
              {{ pick.fieldName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Add Button -->
        <button mat-raised-button color="primary"
        (click)="onGroupByAdded(selectedGroupBy, selectedField)">
        Add GroupBy Option
        </button>
      </div>

      <!-- Added GroupBys -->
      <div class="flex flex-wrap gap-2">
        <button
          *ngFor="let groupBy of model.groupByOptions; let i = index"
          mat-raised-button
          color="primary"
          class="flex items-center space-x-1"
        >
          <span>{{ getDatasetName(groupBy.datasetId) + ', ' + groupBy.fieldToDisplay }}</span>
          <mat-icon (click)="onGroupByRemove(i)">close</mat-icon>
        </button>
      </div>


      <!-- Add Metric Section -->
      <div>
        <!-- Add Metric -->
        <div class="flex gap-4 items-end">
          <!-- Metric Selection -->
          <mat-form-field appearance="fill" class="flex-1">
            <mat-label>Add Metric</mat-label>
            <mat-select [(ngModel)]="selectedMetric">
              <mat-option *ngFor="let metric of availableMetrics" [value]="metric">
                {{ metric.metricName }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Add Button -->
          <button mat-raised-button color="primary"
            (click)="onMetricAdd(selectedMetric)">
            Add Metric
          </button>
        </div>

        <!-- Added Metrics -->
        <div class="flex flex-wrap gap-2">
          <button
            *ngFor="let tableMetric of model.metrics; let i = index"
            mat-raised-button
            color="primary"
            class="flex items-center space-x-1"
          >
            <span>{{ tableMetric.metric.metricName }}</span>
            <mat-icon (click)="onMetricRemove(i)">close</mat-icon>
          </button>
        </div>
      </div>

      <div class="first-input-row">
        <!-- Default Groupby Selection -->
        <mat-form-field appearance="fill" class="flex-1">
          <mat-label>Select Default GroupBys</mat-label>
          <mat-select multiple [(ngModel)]="model.defaultGroupBys" >
            <mat-option *ngFor="let groupBy of model.groupByOptions" [value]="groupBy">
              {{ getDatasetName(groupBy.datasetId) + ', ' + groupBy.fieldToDisplay }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- View Mode -->
    <ng-container *ngIf="rows != null && columns != null">
      <div *ngIf="mode === UserBoardComponentMode.Preview" class="preview-header">
        <mat-icon style="cursor: pointer" (click)="onPreviewButtonClick('edit')">edit</mat-icon>
        <mat-icon style="cursor: pointer" (click)="onPreviewButtonClick('delete')">delete</mat-icon>
      </div>
      <div class="header-bar">
        <div *ngIf="model.header != null && model.header != ''" class="header-text">{{ model.header }}</div>
        <div *ngIf="model.header == null || model.header == ''" class="header-text"></div>
        <!-- <div *ngIf="selectedGroupBys != null && selectedGroupBys.length > 0" class="header-text">{{ getGroupedByText() }}</div> -->

        <div class="group-by-picker">
          <mat-form-field subscriptSizing="dynamic" appearance="fill" class="w-80">
            <mat-label>Select Group By Fields</mat-label>
            <mat-select multiple [(ngModel)]="selectedGroupBys">
              <mat-option *ngFor="let group of model.groupByOptions" [value]="group">
                {{ getDatasetName(group.datasetId) }}
              </mat-option>
              <!-- Custom "Select" button at the end of dropdown -->
              <div class="select-button-container">
                <button mat-button color="primary" (click)="onGroupBySelect()" class="select-button">
                  Select
                </button>
              </div>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <p-table
      [value]="rows"
      showGridlines
      [columns]="columns"
      [resizableColumns]="true"
      [lazy]="false"

      [scrollable]="true"
      scrollHeight="400px"
      [virtualScroll]="true"
      [virtualScrollItemSize]="46"

      (sortFunction)="sortColumn($event)"
      >
        <ng-template #header let-columns>
          <tr>
              <th *ngFor="let col of columns" style="width: 20%;">
                  {{ col.header }}
              </th>
          </tr>
        </ng-template>
        <ng-template #body let-rowData let-rowIndex="rowIndex" let-columns="columns">
          <tr style="height:46px">
              <td *ngFor="let col of columns">
                  {{ rowData[col.field] }}
              </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
  </ng-container>

</div>
